import {getAuthToken} from '../auth';
import {db} from '../db';
import type {PhotoVideo} from './contracts';

/** Selected-detail only, memory-only playback. Native controls seek within the
 * bounded Blob; bearer tokens never enter player URLs, storage or the cache. */
export async function fetchPhotoVideo(video:PhotoVideo,signal:AbortSignal):Promise<Blob>{
 const token=getAuthToken(),database=db;
 if(!token||!video.playbackPath||!Number.isInteger(video.byteLength)||video.byteLength!<1||video.byteLength!>33554432)throw Error('Video unavailable.');
 const runtime=(window as any).process?.env?.VITE_API_URL;
 const base=runtime&&!runtime.startsWith('__')?runtime:import.meta.env.VITE_API_URL||'';
 const allowed=new URL(base||window.location.origin,window.location.origin);
 const target=new URL(`${String(base).replace(/\/+$/,'')}${video.playbackPath}`,window.location.origin);
 const photoPath=/^\/api\/journal\/photos\/[^/]+\/video$/.test(target.pathname);
 const adminPath=/^\/api\/cameras\/admin\/videos\/[a-f0-9-]{36}\/media$/i.test(target.pathname);
 const galleryPath=/^\/api\/journal\/videos\/[a-f0-9-]{36}\/media$/i.test(target.pathname);
 if(!video.playbackPath.startsWith('/api/')||target.origin!==allowed.origin||(!photoPath&&!adminPath&&!galleryPath)||target.hash)
  throw Error('Video access unavailable.');
 const current=()=>{signal.throwIfAborted();if(database!==db||token!==getAuthToken())throw Error('Account changed.');};
 current();
 const response=await fetch(target.href,{headers:{Authorization:`Bearer ${token}`},credentials:'omit',cache:'no-store',redirect:'error',signal:AbortSignal.any([signal,AbortSignal.timeout(45000)])});
 try{current();}catch(error){await response.body?.cancel();throw error;}
 if(!response.ok||response.headers.get('Content-Type')?.split(';')[0]!=='video/mp4'||Number(response.headers.get('Content-Length'))!==video.byteLength){
  await response.body?.cancel();throw Error('Video unavailable. You can still view the photo.');
 }
 const reader=response.body?.getReader();if(!reader)throw Error('Video unavailable.');
 const chunks:Uint8Array<ArrayBuffer>[]=[];let length=0;
 try{for(;;){const {done,value}=await reader.read();current();if(done)break;length+=value.byteLength;
  if(length>video.byteLength!)throw Error('Video exceeded its expected size.');chunks.push(new Uint8Array(value));}
  if(length!==video.byteLength)throw Error('Video download incomplete.');
  return new Blob(chunks,{type:'video/mp4'});
 }finally{await reader.cancel().catch(()=>{});reader.releaseLock();}
}
